import React from 'react'
import NotificationHost from './NotificationHost'

const hostRef = React.createRef<NotificationHost>()
export default hostRef